module.exports = __webpack_public_path__ + "img/jucai4.dec2939d.jpg";